import { ref } from "vue"

export interface NotificationDrawerTarget {
  groupId: string
  target: "category" | "channel"
  targetId: string
  categoryId?: string
  /** Shown as the Drawer's title (the category/channel name). */
  title: string
  /** Set for someone who can manage channels: adds «Настройки канала/категории», which calls it. */
  onEdit?: () => void
}

// Mobile counterpart of the category/channel notification submenus: one bottom sheet with the mute
// and level lists (NotificationTargetPanel), mounted once in app.vue and opened from a long-press
// or the category "..." menu.
const isOpen = ref(false)
const current = ref<NotificationDrawerTarget | null>(null)

export function useNotificationTargetDrawer() {
  function open(target: NotificationDrawerTarget) {
    current.value = target
    isOpen.value = true
  }

  return { isOpen, current, open }
}
